import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const NcDmvCrashReportsService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}/ncdmv_crash_reports`;

  service.getNcDmvCrashReportsBySearchCriteria = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/search${queryString}`, {
      headers,
    });
  };

  return service;
})();

export default NcDmvCrashReportsService;
